import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AuthModule } from '@shared/auth';
import { TrackingModule } from '@shared/tracking';
import { ABTEST_CONFIG } from './abtest.config';
import { ABTestConfig } from './abtest.interface';
import { ABTest } from './abtest.service';

@NgModule({
  imports: [HttpClientModule, AuthModule, TrackingModule],
})
export class ABTestModule {
  static initialize(config: ABTestConfig): ModuleWithProviders {
    return {
      ngModule: ABTestModule,
      providers: [ABTest, { provide: ABTEST_CONFIG, useValue: config }],
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/@shared/abtest/abtest.module.ts